<div class="forgot-password-page-container">
  <div class="forgot-password-content-wrapper">
    <div class="forgot-password-title-wrapper">
      <span class="forgot-password-title">{{
        "forgotPassword.titles.title" | translate
      }}</span>

      <span class="forgot-password-title-wrapper-subtitle">{{
        "forgotPassword.titles.subtitle" | translate
      }}</span>
    </div>

    <div class="forgot-password-wrapper-form">
      <div class="forgot-password-fixed-form-container">
        <ng-gencat-form
          (loaded)="forgotPasswordFormLoaded($event)"
          [controls]="forgotPasswordFormConfig"
        />

        <div class="forgot-password-button-wrapper">
          <button-component
            text="forgotPassword.button"
            customId="request_password_reset_button"
            [tmobBtnStyle]="primaryButton"
            [appButtonDisable]="!readyforgotPasswordSignal()"
            (click)="forgotPassword()"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="forgot-password-wrapper-image">
    <div class="image-forgot-password-background"></div>
  </div>
</div>
